module.exports = __webpack_public_path__ + "img/car_damage_outline.817f18ec.svg";